module.exports = __webpack_public_path__ + "img/bi.7cab58a5.png";